import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-ink px-4 sm:px-8 lg:px-16 pt-16 pb-8" data-testid="site-footer">
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-6">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-flame mb-4">Say hello</p>
          <a
            data-testid="footer-email-link"
            href="mailto:Maddietweetrbg@gmail.com"
            className="font-serif text-2xl sm:text-3xl text-bone hover:text-flame transition-colors duration-300 break-all"
          >
            Maddietweetrbg@gmail.com
          </a>
          <p className="mt-6 max-w-sm text-sm text-ash leading-relaxed">
            Automotive and personal photography. Golden hours, night meets, and everything in between.
          </p>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-faint mb-4">Menu</p>
          <div className="flex flex-col gap-3">
            <Link to="/" data-testid="footer-link-home" className="text-sm text-ash hover:text-bone transition-colors w-max">Index</Link>
            <Link to="/gallery" data-testid="footer-link-gallery" className="text-sm text-ash hover:text-bone transition-colors w-max">The Work</Link>
            <Link to="/book" data-testid="footer-link-book" className="text-sm text-ash hover:text-bone transition-colors w-max">Book a Session</Link>
            <Link to="/client-access" data-testid="footer-link-client-access" className="text-sm text-ash hover:text-bone transition-colors w-max">Client Access</Link>
            <Link to="/admin" data-testid="footer-link-admin" className="text-sm text-faint hover:text-bone transition-colors w-max">Studio Login</Link>
          </div>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-faint mb-4">Galleries</p>
          <div className="flex flex-col gap-3">
            <Link to="/gallery?cat=automotive" data-testid="footer-link-automotive" className="group flex items-center gap-2 text-sm text-ash hover:text-bone transition-colors w-max">
              Automotive <ArrowUpRight size={13} className="text-flame opacity-0 group-hover:opacity-100 transition-opacity" />
            </Link>
            <Link to="/gallery?cat=personal" data-testid="footer-link-personal" className="group flex items-center gap-2 text-sm text-ash hover:text-bone transition-colors w-max">
              Personal / Portrait <ArrowUpRight size={13} className="text-flame opacity-0 group-hover:opacity-100 transition-opacity" />
            </Link>
          </div>
        </div>
      </div>
      <div className="mt-16 flex flex-col sm:flex-row justify-between gap-3 border-t border-white/10 pt-6">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-faint">© 2026 Maddie Reiss Photography</p>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-faint">Cars after dark — people in the light</p>
      </div>
    </footer>
  );
}
